module.exports = __webpack_public_path__ + "static/img/role004.e3f3779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role004.jpg
// module id = o1c1
// module chunks = 1